// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import "./Ecommerce.css";
// const Productbysubcategory = () => {
//   const { subcategoryId } = useParams();
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get(
//           `https://vogelkoparchitects.com/api/api/mproducts/by-subcategory/${subcategoryId}/`
//         );
//         setProducts(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchProducts();
//   }, [subcategoryId]);

//   if (loading) {
//     return (
//       <div className="ecommerce-productbysubcategory-loading">
//         <div className="loading-spinner"></div>
//         Loading products...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="ecommerce-productbysubcategory-error">
//         <div className="error-icon">!</div>
//         Error: {error}
//         <button
//           onClick={() => window.location.reload()}
//           className="retry-button"
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Updated Banner Section */}
//       <div className="ecommerce-productbysubcategory-banner">
//         <div className="ecommerce-productbysubcategory-banner-overlay"></div>
//         <div className="ecommerce-productbysubcategory-banner-content">
//           <h1>Our Collection</h1>
//           <p>Discover our premium selection of products</p>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="ecommerce-productbysubcategory-container">
//         <div className="ecommerce-productbysubcategory-header">
//           <h2>Featured Products</h2>
//           <div className="ecommerce-productbysubcategory-filter">
//             {/* You can add filter options here later */}
//           </div>
//         </div>

//         <div className="ecommerce-productbysubcategory-grid">
//           {products.map((product) => (
//             <div
//               key={product.id}
//               className="ecommerce-productbysubcategory-card"
//             >
//               <div className="ecommerce-productbysubcategory-image-container">
//                 {product.product_images.length > 0 ? (
//                   <img
//                     src={product.product_images[0]}
//                     alt={product.product_name}
//                     className="ecommerce-productbysubcategory-image"
//                   />
//                 ) : (
//                   <div className="ecommerce-productbysubcategory-image-placeholder">
//                     <span>No Image Available</span>
//                   </div>
//                 )}
//                 {product.is_sold_out && (
//                   <div className="ecommerce-productbysubcategory-sold-out-badge">
//                     Sold Out
//                   </div>
//                 )}
//               </div>

//               <div className="ecommerce-productbysubcategory-details">
//                 <h3 className="ecommerce-productbysubcategory-product-name">
//                   {product.product_name}
//                 </h3>

//                 <div className="ecommerce-productbysubcategory-price-container">
//                   {product.discount > 0 ? (
//                     <>
//                       <span className="ecommerce-productbysubcategory-original-price">
//                         ${product.price.toFixed(2)}
//                       </span>
//                       <span className="ecommerce-productbysubcategory-discounted-price">
//                         ${(product.price - product.discount).toFixed(2)}
//                       </span>
//                       <span className="ecommerce-productbysubcategory-discount-percent">
//                         {Math.round((product.discount / product.price) * 100)}%
//                         OFF
//                       </span>
//                     </>
//                   ) : (
//                     <span className="ecommerce-productbysubcategory-price">
//                       ${product.price.toFixed(2)}
//                     </span>
//                   )}
//                 </div>

//                 <button className="ecommerce-productbysubcategory-view-button">
//                   View Details
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Productbysubcategory;

import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom"; // Import Link
import axios from "axios";
import "./Ecommerce.css";

const Productbysubcategory = () => {
  const { subcategoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `https://vogelkoparchitects.com/api/api/mproducts/by-subcategory/${subcategoryId}/`,
        );
        setProducts(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, [subcategoryId]);

  if (loading) {
    return (
      <div className="ecommerce-productbysubcategory-loading">
        <div className="loading-spinner"></div>
        Loading products...
      </div>
    );
  }

  if (error) {
    return (
      <div className="ecommerce-productbysubcategory-error">
        <div className="error-icon">!</div>
        Error: {error}
        <button
          onClick={() => window.location.reload()}
          className="retry-button"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Updated Banner Section */}
      <div className="ecommerce-productbysubcategory-banner">
        <div className="ecommerce-productbysubcategory-banner-overlay"></div>
        <div className="ecommerce-productbysubcategory-banner-content">
          <h1>Our Collection</h1>
          <p>Discover our premium selection of products</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="ecommerce-productbysubcategory-container">
        <div className="ecommerce-productbysubcategory-header">
          <h2>Featured Products</h2>
          <div className="ecommerce-productbysubcategory-filter">
            {/* You can add filter options here later */}
          </div>
        </div>

        <div className="ecommerce-productbysubcategory-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="ecommerce-productbysubcategory-card"
            >
              <div className="ecommerce-productbysubcategory-image-container">
                {product.product_images.length > 0 ? (
                  <Link to={`/Productbydetail/${product.id}`}>
                    <img
                      src={product.product_images[0]}
                      alt={product.product_name}
                      className="ecommerce-productbysubcategory-image"
                    />
                  </Link>
                ) : (
                  <Link to={`/Productbydetail/${product.id}`}>
                    <div className="ecommerce-productbysubcategory-image-placeholder">
                      <span>No Image Available</span>
                    </div>
                  </Link>
                )}
                {product.is_sold_out && (
                  <div className="ecommerce-productbysubcategory-sold-out-badge">
                    Sold Out
                  </div>
                )}
              </div>

              <div className="ecommerce-productbysubcategory-details">
                <Link to={`/Productbydetail/${product.id}`}>
                  <h3 className="ecommerce-productbysubcategory-product-name">
                    {product.product_name}
                  </h3>
                </Link>

                <div className="ecommerce-productbysubcategory-price-container">
                  {product.discount > 0 ? (
                    <>
                      <span className="ecommerce-productbysubcategory-original-price">
                        ${product.price.toFixed(2)}
                      </span>
                      <span className="ecommerce-productbysubcategory-discounted-price">
                        ${(product.price - product.discount).toFixed(2)}
                      </span>
                      <span className="ecommerce-productbysubcategory-discount-percent">
                        {Math.round((product.discount / product.price) * 100)}%
                        OFF
                      </span>
                    </>
                  ) : (
                    <span className="ecommerce-productbysubcategory-price">
                      ${product.price.toFixed(2)}
                    </span>
                  )}
                </div>

                <Link
                  to={`/Productbydetail/${product.id}`}
                  className="ecommerce-productbysubcategory-view-button"
                >
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Productbysubcategory;
